import React from 'react';
import { useHistory } from 'react-router';

import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { ButtonBase, Grid, Typography } from '@mui/material';

import { isRetrievalOnly } from '@utils/environment';

import ArrowRightIcon from 'jsx:@assets/svgs/arrowRight.svg';
import EmailIcon from 'jsx:@assets/svgs/email.svg';
import PhoneIcon from 'jsx:@assets/svgs/phone.svg';

import { ArrowLeftIcon, VerificationItem } from './styles';

function ForgotPasswordPage() {
	const history = useHistory();
	const generateRoutePath = useGenerateRoutePath();

	return (
		<>
			<Grid container direction="column" alignItems="center" justifyContent="center">
				<Typography variant="body1" mb={2}>
					<b>
						{isRetrievalOnly()
							? 'Please select verification method to create your password.'
							: 'Please select verification method used to recover your password.'}
					</b>
				</Typography>

				<Grid container>
					<Grid item xs={12} mb={2}>
						<VerificationItem
							onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.FORGOT_PASSWORD_VIA_EMAIL))}
						>
							<Grid item display={'flex'} alignItems={'center'} justifyContent={'center'}>
								<EmailIcon />

								<Typography variant="caption" ml={2}>
									<b>Email</b>
								</Typography>
							</Grid>

							<ArrowRightIcon />
						</VerificationItem>
					</Grid>

					<Grid item xs={12} mb={2}>
						<VerificationItem
							onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.FORGOT_PASSWORD_VIA_PHONE))}
						>
							<Grid item display={'flex'} alignItems={'center'} justifyContent={'center'}>
								<PhoneIcon />

								<Typography variant="caption" ml={2}>
									<b>SMS</b>
								</Typography>
							</Grid>

							<ArrowRightIcon />
						</VerificationItem>
					</Grid>
				</Grid>
			</Grid>

			<Grid item xs={12} textAlign={'right'} mt={4}>
				<ButtonBase
					sx={{ textTransform: 'uppercase', height: 32 }}
					onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.LOGIN))}
				>
					<ArrowLeftIcon />
					<Typography variant={'body2'} color={'black'}>
						<b>Back to login</b>
					</Typography>
				</ButtonBase>
			</Grid>
		</>
	);
}

export default ForgotPasswordPage;
